import { FormCreate } from '@components';
import validate from './validate';

const Form = FormCreate('IncidentTypeForm', validate);

export default function IncidentTypeForm({ ...rest }) {
  return (
    <Form
      {...rest}
      fields={[
        {
          name: 'description',
          component: 'input',
          type: 'text',
          label: 'Descrição',
          inputProps: {
            placeholder: 'Informe a descrição',
          },
        },
        {
          name: 'purpose',
          component: 'select',
          type: 'select',
          label: 'Natureza:',
          inputProps: {
            options: [
              { key: 0, text: 'Selecione', value: '' },
              { key: 1, text: 'Entrega', value: 'ENTREGA' },
              { key: 2, text: 'Transporte', value: 'TRANSPORTE' },
            ],
          },
        },
      ]}
    />
  );
}
